import React from "react";
import EnquiryForm from "../../components/UserComponents/inquiry/EnquiryForm";

const BookInquiry = () => {
  return (
    <div>
      <EnquiryForm />
    </div>
  );
};

export default BookInquiry;
